import React from "react";

const footer = "w-full pin-b py-2 px-4 border-box text-xs";

export default () => {
  return <footer className={footer}>&copy; GrokOn</footer>;
};
